import { IObservable, Subject } from '~/rage/utils';
import { IVehicleRegistrationDetails } from '~/shared';
import { IVehicleRegistrationService } from './vehicleRegistrationServiceTypes';

export class VehicleRegistrationServiceStub
	implements IVehicleRegistrationService
{
	private readonly registrationPrice = new Subject<number | null>(20_000);
	private readonly detailsStub: IVehicleRegistrationDetails = {
		modelName: 'BM X5M F70',
		bodyColor: 'CC0003',
		vinNumber: '2404000000004',
		bodyType: 'Кроссовер',
		priceCash: 24_000_000,
		mileage: 950,
	};

	constructor() {
		setInterval(() => this.registrationPrice.next);
	}

	public async getDetails(
		_vehicleId: string,
	): Promise<IVehicleRegistrationDetails> {
		return this.detailsStub;
	}

	public getRegistrationPrice(): IObservable<number | null> {
		return this.registrationPrice;
	}

	public async register(vehicleId: string, region: string): Promise<void> {
		console.log('vehicleRegistration:register', { vehicleId, region });
	}

	public async exitMenu(): Promise<void> {
		console.log('vehicleRegistration:exitMenu');
	}
}
